export class QuoteRequest {
  worksheetId: string;
  shipViaOption: string;
  comment: string;
  specialHandling: string;
  packingListLocation: string;
  isPackingListPriced: boolean;
  packingListCopiesCount: number;
  invoiceLocation: string;
  shippingNotificationEmail: string;
  completeDelivery: boolean;
  requestedDeliveryDate: string;
  purchaseOrderNumber: string;
  projectName: string;
  projectId: string;
  poDeliveryDate: string;
  customerPOIssueDate: string;
  originalPromiseDeliveryDate: string;
  originalPromiseShipDate: string;
  isSaturdayDelivery: boolean;
  isLiftGateRequired: boolean;
  isInsideDeliveryRequired: boolean;
  isRealQuote: boolean;
  isCustomDelivery: boolean;
  forceSimulation: boolean;
  isCheckout: boolean;
  generatePORRequired: boolean;
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/quote-request.ts